var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.6 16 5.1-5.1c.3-.3.3-.9 0-1.2l-1.4-1.4c-.3-.3-.9-.3-1.2 0L16 13.4l-5.1-5.1c-.3-.3-.9-.3-1.2 0L8.2 9.7c-.3.3-.3.9 0 1.2l5.1 5.1-5.1 5.1c-.3.3-.3.9 0 1.2l1.4 1.4c.3.3.9.3 1.2 0l5.1-5.1 5.1 5.1c.3.3.9.3 1.2 0l1.4-1.4c.3-.3.3-.9 0-1.2z"
})));
export default SvgIconClose;